/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/require-await */
import { ConstantsUtil as CommonConstantsUtil } from '@reown/appkit-common';
import { CoreHelperUtil } from '@reown/appkit-controllers';
import { PresetsUtil } from '@reown/appkit-utils';
import { bitcoin } from '@reown/appkit/networks';
import { MethodNotSupportedError } from '../errors/MethodNotSupportedError.js';
import { AddressPurpose } from '../utils/BitcoinConnector.js';
import { ProviderEventEmitter } from '../utils/ProviderEventEmitter.js';
import { UnitsUtil } from '../utils/UnitsUtil.js';
export class OKXConnector extends ProviderEventEmitter {
    constructor({ wallet, requestedChains, getActiveNetwork, imageUrl }) {
        super();
        this.id = 'OKX';
        this.name = 'OKX Wallet';
        this.chain = 'bip122';
        this.type = 'ANNOUNCED';
        this.explorerId = PresetsUtil.ConnectorExplorerIds[CommonConstantsUtil.CONNECTOR_ID.OKX];
        this.provider = this;
        this.requestedChains = [];
        this.wallet = wallet;
        this.requestedChains = requestedChains;
        this.getActiveNetwork = getActiveNetwork;
        this.imageUrl = imageUrl;
    }
    get chains() {
        return this.requestedChains.filter(chain => chain.caipNetworkId === bitcoin.caipNetworkId);
    }
    async connect() {
        const result = await this.wallet.connect();
        this.bindEvents();
        return result.address;
    }
    async disconnect() {
        this.unbindEvents();
        await this.wallet.disconnect();
    }
    async getAccountAddresses() {
        const accounts = await this.wallet.getAccounts();
        const publicKeyOfActiveAccount = await this.wallet.getPublicKey();
        const accountList = accounts.map(account => ({
            address: account,
            purpose: AddressPurpose.Payment,
            publicKey: publicKeyOfActiveAccount
        }));
        return accountList;
    }
    async signMessage(params) {
        const protocol = params.protocol === 'bip322' ? 'bip322-simple' : params.protocol;
        return this.wallet.signMessage(params.message, protocol);
    }
    async sendTransfer(params) {
        const network = this.getActiveNetwork();
        if (!network) {
            throw new Error('No active network available');
        }
        const from = (await this.wallet.getAccounts())[0];
        if (!from) {
            throw new Error('No account available');
        }
        const result = await this.wallet.send({
            from,
            to: params.recipient,
            value: UnitsUtil.parseSatoshis(params.amount, network)
        });
        return result.txhash;
    }
    async signPSBT(params) {
        const psbtHex = Buffer.from(params.psbt, 'base64').toString('hex');
        const signedPsbtHex = await this.wallet.signPsbt(psbtHex);
        let txid = undefined;
        if (params.broadcast) {
            txid = await this.wallet.pushPsbt(signedPsbtHex);
        }
        return {
            psbt: Buffer.from(signedPsbtHex, 'hex').toString('base64'),
            txid
        };
    }
    async switchNetwork(_caipNetworkId) {
        throw new Error(`${this.name} wallet does not support network switching`);
    }
    request(_args) {
        return Promise.reject(new MethodNotSupportedError(this.id, 'request'));
    }
    bindEvents() {
        this.unbindEvents();
        this.wallet.on('accountChanged', account => {
            if (typeof account === 'object' && account && 'address' in account) {
                this.emit('accountsChanged', [account.address]);
            }
        });
        this.wallet.on('disconnect', () => {
            this.emit('disconnect');
        });
    }
    unbindEvents() {
        this.wallet.removeAllListeners();
    }
    static getWallet(params) {
        if (!CoreHelperUtil.isClient()) {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const okxwallet = window?.okxwallet;
        const wallet = okxwallet?.bitcoin;
        /**
         * OKX doesn't provide a way to get the image URL specifally for bitcoin
         * so we use the icon for cardano as a fallback
         */
        const imageUrl = okxwallet?.cardano?.icon || '';
        if (wallet) {
            return new OKXConnector({ wallet, imageUrl, ...params });
        }
        return undefined;
    }
    async getPublicKey() {
        return this.wallet.getPublicKey();
    }
}
//# sourceMappingURL=OKXConnector.js.map